import React from "react";
import get from "lodash/get";
import startCase from "lodash/startCase";
import { useFormikContext } from "formik";
import DebounceTextarea from "components/DebounceTextarea";
import { getFieldPath } from "utils/form";
import { useIsManifestEditMode } from "utils/hooks/manifest";
import classnames from "classnames";
import { DEFAULT_DEBOUNCE } from "utils/constants/form";

const FieldListFactory = ({ name, config }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const isEditMode = useIsManifestEditMode();

  return config.map((field, fieldIx) => {
    const fieldName = getFieldPath(name, field.name, "");
    const fieldValue = get(values, fieldName);
    const fieldLabel = field.label || startCase(field.name);
    const fieldPlaceholder = field.placeholder || `Set a field ${field.name}`;
    return (
      <div
        key={fieldIx}
        className={classnames("w-100", {
          pt3: fieldIx
        })}
      >
        <label className="f6 mb2 dib fw6">{fieldLabel}</label>
        <DebounceTextarea
          inputValue={fieldValue}
          debounce={DEFAULT_DEBOUNCE}
          minRows={1}
          placeholder={fieldPlaceholder}
          name={fieldName}
          disabled={Boolean(field.disabled || isEditMode)}
          valueSet={(val) => {
            setFieldValue(fieldName, val);
            if (!get(touched, fieldName)) {
              setFieldTouched(fieldName, true);
            }
          }}
        />
      </div>
    );
  });
};

export default FieldListFactory;
